import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import MainRouter from './routers';
import {storeFactory} from './reducers';
import {languages} from "./constants";
import i18n from './i18n.js';

import {userConsts as C} from "./constants/users";
import {I18nextProvider} from "react-i18next";
//import registerServiceWorker from "./registerServiceWorker";


const initialState = {
    persistStore: {
        language: {
            activeLanguage: languages.RUS,
            locale: languages.ENG,
        },
        isAuthorized: false,
    },
    user: {
        login: "",
        email: "",
        avatar: null,
        status: "",
        statusLoad: C.NOT_LOADED,
        rank: "",
        firstName: "",
        lastName: "",
        skills: "",
        phone: "",
        birthday: "",
        city: "",
        workPlace: "",
        university: "",
        rewards: {
            gold: null,
            silver: null,
            bronze: null,
        },

        ratingPlace: null,
        score: null,
        championships: [],
        notifications: [],

        isNewNotify: false,
        forum: {
            subscriptions: [],
            /*commends: {
                plus: [],
                minus: [],
            },
            bookmarks: [],*/
        },
        //новые стейты для анкеты
        tgNickname: "",
        cityOther: "",
        eduLevel: "",
        eduLevelOther:"",
        gradYear: "",
        universityOther: "",
        major: "",
        majorOther: "",
        codingSkills: "",
        codingSkillsOther: "",
        expLevel: "",
        cvUrl: "",
    },
    championships: [],
    rating: [],
    champs: [],
    vacancies: [],
    forum: {
        commends: {}, 
        /*commends: {
          plus: [],
          minus: [],
        },*/
        navPanelWidth: 288,
        threads: [],
        thread: {},
        topics: {},
        lenta: {
            topics: [], 
            champs: [],
            champFilter: 0,
            topicFilter: [0, 1],
            selectedPopularTab: 1,
        },
    },
    //OLD CODE, KEPT JUST IN CASE
    /*drafts: {
        data: [
            {
                id: 0,
                title: 'Название статьи',
                dateCreate: new Date('2021-04-27T14:40:04.824Z'),
                content: 'первая статья',
                cover: '',
            },
            {
                id: 1,
                title: 'Еще одно название',
                dateCreate: new Date('2021-03-27T14:40:04.824Z'),
                content: 'вторая статья',
                cover: '',
            },
            {
                id: 2,
                title: 'Художественная ментальность монотонно трансформирует деструктивный символический метафоризм',
                dateCreate: new Date('2021-03-23T14:40:04.824Z'),
                content: 'третья статья',
                cover: {
                    url: 'https://upload.wikimedia.org/wikipedia/commons/8/8b/Ciel_de_Nice.jpg',
                    x: 0,
                    y: 0,
                    scale: 1,
                    basicWidth: 2376,
                    basicHeight: 3168
                }
            },
        ],
        selectedID: 2
    },*/
};


const store = storeFactory(initialState);


const render = () =>
    ReactDOM.render(
        <Provider store={store}>
            <I18nextProvider i18n={i18n}>
                <BrowserRouter>
                    <MainRouter/>
                </BrowserRouter>
            </I18nextProvider>
        </Provider>,
        document.getElementById('root'));

store.subscribe(render);
store.subscribe(() => {
    localStorage.setItem(process.env.LOCAL_STORAGE, JSON.stringify(store.getState()))
});

render();

//registerServiceWorker();



// WEBPACK FOOTER //
// src/index.jsx